// Lost-reason options for the "mark opportunity Lost" flow.
//
// Extracted from OpportunityDetailPage's inline <select> so a second
// entry point (the Data Needed cleanup card's "Mark lost" action) can
// offer the exact same reasons without drifting. The values are written
// verbatim into opportunities.outcome_reason (free-text column, no DB
// enum) — do not rename a value once shipped, that breaks existing rows'
// lost-reason breakdown reporting.

export interface LostReasonOption {
  value: string;
  label: string;
}

export const LOST_REASON_OPTIONS: readonly LostReasonOption[] = [
  { value: "went_to_competitor", label: "Went with a competitor" },
  { value: "price", label: "Price" },
  { value: "timing", label: "Timing — not right now" },
  { value: "went_quiet", label: "Went quiet — no response" },
  { value: "stayed_as_is", label: "Chose to stay as-is" },
  { value: "not_a_fit", label: "Not a fit for us" },
  { value: "other", label: "Other" },
];
